import {
  Button,
  Card,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Form, Formik } from "formik";
// @ts-ignore
import { MUIEditorState } from "react-mui-draft-wysiwyg";
import LabelsContext from "../../../lang/LabelsContext";
import EnumReviewStatus from "../../../utils/enum/EnumReviewStatus";
import { isUserAssociateEditor, muiControls, richTextStateFromHTML } from "../../../utils/Utils";
import RichText from "../../system/rich-text/RichText";
import MakeDecisionButtonService, { MakeDecisionButtonServiceType } from "./MakeDecisionButtonService";
import useStyles from "./MakeDecisionButtonStyle";

interface MakeDecisionButtonType {
  label: string;
  reviewStatus: string;
  styleButton?: any;
  editorDecision?: boolean;
  message?: string;
}

export default function MakeDecisionButton({ buttonProps, article, style, editorDecision, message }: any) {
  const { label, reviewStatus, styleButton } = buttonProps as MakeDecisionButtonType;
  const classes = useStyles();
  const { Labels } = LabelsContext();

  const {
    mailSuggestion,
    openDialog,
    handleOpenDialog,
    handleCloseDialog,
    associateList,
    mailSuggestionAssociateSelect,
    setMailSuggestionAssociateSelect,
    sendMail,
    authData,
    mailRef,
    commentRef,
  }: MakeDecisionButtonServiceType = MakeDecisionButtonService({ reviewStatus, article, editorDecision, message });

  return (
    <>
      <Button
        key={reviewStatus}
        variant="contained"
        color={article?.status === reviewStatus ? "primary" : "default"}
        className={classes.button}
        style={style ? style : styleButton}
        onClick={handleOpenDialog}
      >
        {label}
      </Button>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{Labels.NEW_EMAIL}</DialogTitle>

        {mailSuggestion && (
          <Formik
            enableReinitialize={true}
            initialValues={{
              to: mailSuggestion.to ? mailSuggestion.to : [],
              subject: mailSuggestion.subject ? mailSuggestion.subject : "",
              message: message
                ? richTextStateFromHTML(message)
                : mailSuggestion.text
                ? richTextStateFromHTML(mailSuggestion.text)
                : MUIEditorState.createEmpty(),
              commentsToEditor: MUIEditorState.createEmpty(),
            }}
            onSubmit={(values) => sendMail(values)}
          >
            {({ handleBlur, values, touched, errors, handleChange, handleSubmit, setFieldValue }) => (
              <Form>
                <DialogContent>
                  <Grid container direction="column">
                    {reviewStatus !== EnumReviewStatus.ASSOCIATE_EDITOR ? (
                      <>
                        {isUserAssociateEditor(authData) ? (
                          <TextField
                            variant="outlined"
                            margin="normal"
                            label={Labels.TO}
                            value={"Prof. dr. Wytske Fokkens"}
                            disabled={true}
                            fullWidth
                          />
                        ) : (
                          <Grid item>
                            <Autocomplete
                              className={classes.paddingBottom2}
                              multiple
                              id="tags-to"
                              value={values.to}
                              onChange={(event, value) => setFieldValue("to", value)}
                              options={[{ title: "exampleTest@gmail.com" }].map((option) => option.title)}
                              freeSolo
                              renderTags={(value: string[], getTagProps) =>
                                value.map((option: string, index: number) => (
                                  <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                                ))
                              }
                              renderInput={(params) => <TextField {...params} label={Labels.TO} variant="outlined" />}
                            />
                          </Grid>
                        )}
                      </>
                    ) : (
                      <Grid item>
                        <Autocomplete
                          id="combo-box-demo"
                          options={associateList}
                          getOptionLabel={(option) => option.name}
                          value={mailSuggestionAssociateSelect}
                          onChange={(event, value) => setMailSuggestionAssociateSelect(value)}
                          fullWidth
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              margin="normal"
                              id="type"
                              name="type"
                              label={Labels.TO}
                            />
                          )}
                        />
                      </Grid>
                    )}
                    <Grid item className={classes.paddingBottom2}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        id="subject"
                        name="subject"
                        label={Labels.SUBJECT}
                        value={values.subject}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.subject && Boolean(errors.subject)}
                        helperText={touched.subject && errors.subject}
                        fullWidth
                      />
                    </Grid>
                    <Grid item>
                      <Card className={classes.card}>
                        <Typography variant="subtitle1">Mail suggestion</Typography>
                        <Divider className={classes.divider} />
                        <RichText
                          muiEditorRef={mailRef}
                          placeholder={Labels.PLACEHOLDER_WRITE_COMMENT}
                          controls={muiControls}
                        />
                      </Card>
                    </Grid>
                    {isUserAssociateEditor(authData) && (
                      <Grid item>
                        <Card className={classes.card}>
                          <Typography variant="subtitle1">Comments to Editor (only the editor will see)</Typography>
                          <Divider className={classes.divider} />
                          <RichText
                            muiEditorRef={commentRef}
                            placeholder={Labels.PLACEHOLDER_WRITE_COMMENT}
                            controls={muiControls}
                          />
                        </Card>
                      </Grid>
                    )}
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseDialog} color="primary">
                    {Labels.CANCEL}
                  </Button>
                  <Button variant="contained" color="primary" type="submit">
                    {Labels.SEND}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        )}
      </Dialog>
    </>
  );
}

export type { MakeDecisionButtonType };
